<template>
  <div class="tabs__item item_5">
    <div class="tab__content">
      <div class="tab__content__title">
        <p class="tab__content__title_large">{{ $t("supportTab.bigHeading") }}</p>
      </div>
    </div>
    <div class="tab__content__active">
      <div class="tab__userblock">
        <a href="#" @click="openContact" class="userblock__item">
          <img class="userblock__item__img" src="../assets/img/envelopes.svg" alt>
          <div class="userblock__item__text">{{ $t("supportTab.buttonSendFeedback") }}</div>
        </a>
        <a href="#" @click="openSupport" class="userblock__item">
          <img
            class="userblock__item__img"
            src="../assets/img/computer-invite-to-client-portal.svg"
            alt="support"
          >
          <div class="userblock__item__text">{{ $t("supportTab.buttonFAQ") }}</div>
        </a>
        <a href="#" @click="openDemo" class="userblock__item">
          <img
            style="width: 40px; height: 40px; margin-bottom: 5px; margin-top: 16px;"
            class="userblock__item__img"
            src="../assets/img/headphones.svg"
            alt="demo"
          >
          <div class="userblock__item__text">{{ $t("supportTab.buttonScheduleDemo") }}</div>
        </a>
      </div>
    </div>
    <div class="tab__content__title">
      <p class="tab__content__title_large">{{ $t("supportTab.sectionRateUsHeading") }}</p>
    </div>
    <div class="tab__content__active">
      <div class="tab__userblock_reit">
        <div class="rating" :change-disabled="checked_rate != ''">
          <a @click="starOnChange" href="#"
            :class="(checked_rate == 'rating-input-1-5' ? 'checked' : '')">
            <input type="radio" :checked="checked_rate == 'rating-input-1-5'" class="rating-input" id="rating-input-1-5" name="rating-input-1">
            <label for="rating-input-1-5" class="rating-star"></label>
          </a>
          <a @click="starOnChange" href="#"
            :class="(checked_rate == 'rating-input-1-4' ? 'checked' : '')">
            <input type="radio" :checked="checked_rate == 'rating-input-1-4'" class="rating-input" id="rating-input-1-4" name="rating-input-1">
            <label for="rating-input-1-4" class="rating-star"></label>
          </a>
          <div :class="(checked_rate == 'rating-input-1-3' ? 'checked' : '')">
            <input @click="starOnChange" type="radio" :checked="checked_rate == 'rating-input-1-3'" class="rating-input" id="rating-input-1-3" name="rating-input-1">
            <label for="rating-input-1-3" class="rating-star"></label>
          </div>
          <div :class="(checked_rate == 'rating-input-1-2' ? 'checked' : '')">
            <input @click="starOnChange" type="radio" :checked="checked_rate == 'rating-input-1-2'" class="rating-input" id="rating-input-1-2" name="rating-input-1">
            <label for="rating-input-1-2" class="rating-star"></label>
          </div>
          <div :class="(checked_rate == 'rating-input-1-1' ? 'checked' : '')">
            <input @click="starOnChange" type="radio" :checked="checked_rate == 'rating-input-1-1'" class="rating-input" id="rating-input-1-1" name="rating-input-1">
            <label for="rating-input-1-1" class="rating-star"></label>
          </div>
        </div>
        <div v-if="checked_rate != '' && checked_rate != undefined" style="margin-bottom: 20px">
          <a href="#" @click="resetRating" id='reset_rating'>{{ $t("supportTab.buttonEditReview") }}</a>
        </div>
        <div class="reit__text" v-if="checked_rate == '' || checked_rate == undefined">
          <div class="text_poor">{{ $t("supportTab.labelMinRate") }}</div>
          <div class="text__ex">{{ $t("supportTab.labelMaxRate") }}</div>
        </div>
        <div class="success-msg">{{ $t("supportTab.sectionRateUsThankMessage") }}</div>
      </div>
    </div>
    <!--
    <div class="tabs__banner">
      <div class="banner2__container">
        <header>{{ $t("banners.banner2Header") }}</header>
        <div class="__mask"></div>
        <div class="__list">
          <ul>
            <li>{{ $t("banners.banner2List_1") }}</li>
            <li>{{ $t("banners.banner2List_2") }}</li>
            <li>{{ $t("banners.banner2List_3") }}</li>
          </ul>
          <ul>
            <li>{{ $t("banners.banner2List_4") }}</li>
            <li>{{ $t("banners.banner2List_5") }}</li>
          </ul>
        </div>
        <footer>
          <a href="#" @click="openUpgradePage">{{ $t("banners.learnMore") }}</a>
        </footer>
      </div>
    </div>
    -->
  </div>
</template>

<script>
import * as GA from '@/assets/js/ga.js'

export default {
  name: 'tabSupport',
  props: ['loggedIn', 'pivotId', 'checked_rate', 'userData'],
  methods: {
    starOnChange: function (event) {
      event.stopPropagation()
      let e = event.target

      if (e.tagName === 'A') {
        event.preventDefault()
        e = e.firstElementChild
      }

      const act = e.parentNode.parentNode.querySelector('.checked')

      if (act !== null || this.checked_rate !== '') {
        event.preventDefault()
        return false
      } else {
        if (e.checked) {
          e.parentNode.classList.add('checked')
          const p = e.parentNode
          p.parentNode.classList.add('input-success')

          setTimeout(function () {
            p.parentNode.classList.remove('input-success')
          }, 5000)

          if (p.tagName === 'A') {
            Wix.Settings.openReviewInfo() // eslint-disable-line
          }

          this.ax(e)
        } else e.parentNode.classList.remove('checked')
      }
    },
    ax: function (e) {
      GA.track('wixpay_rate_app', {
        uid: this.loggedIn ? this.userData.business_id : null,
        stars: e.id.substr(15)
      })

      this.$emit('changeDesign', { 'checked_rate': e.id })
    },
    openContact: function (event) {
      GA.track('wixpay_contact_vcita', {
        uid: this.loggedIn ? this.userData.business_id : null
      })

      window.open(`https://www.${this.$vcitaAddress}/contact`, '_blank')
    },
    openDemo: function (event) {
      GA.track('wixpay_demo_vcita', {
        uid: this.loggedIn ? this.userData.business_id : null
      })

      window.open(`https://live.${this.$vcitaAddress}/site/vcita.sales/online-scheduling?service=289tixik1ymrp6hw&vtm_cp=wix_payments`, '_blank')
    },
    openSupport: function () {
      GA.track('wixpay_FAQ', {
        uid: this.loggedIn ? this.userData.business_id : null
      })

      window.open(`https://support.${this.$vcitaAddress}/hc/en-us`, '_blank')
    },
    openUpgradePage: function () {
      this.$emit('openUpgradePage')
    },
    resetRating: function (event) {
      this.$emit('changeDesign', { 'checked_rate': '' })
    }
  },
  mounted: function () {
    this.$emit('mounted', true)
  }
}
</script>
